module.exports = __webpack_public_path__ + "media/vo-03-08.65ef5e6e.mp3";